import { render } from "./FipeIconInfo.vue?vue&type=template&id=ebf3c8e2&scoped=true"
import script from "./FipeIconInfo.vue?vue&type=script&lang=js"
export * from "./FipeIconInfo.vue?vue&type=script&lang=js"

import "./FipeIconInfo.vue?vue&type=style&index=0&id=ebf3c8e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf3c8e2"]])

export default __exports__